/**
 * Defines a validator with a context
 * @param {string|ValidatorType} name The validator
 * @param {object} context The context to pass to the validator
 * @return {object} The context validation definition
 */
function cxt(name, context) {
  return [name, context];
}

module.exports = {
  cxt,
};
